import React, { PureComponent } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import colors from '../../../theme/Colors';
import size from '../../../theme/Fonts';
import images from '../../../theme/Images';
import Utility from '../../../utils/Utility';
import FastImageView from '../../FastImageView';
import { getScreenWidth } from '../../../utils/LayoutUtility';
import { memoize } from 'lodash';

class RoutineScoreFeatureCard extends PureComponent {
  render() {
    const {
      itemData: {
        title = '',
        body = '',
        backgroundColor = '',
        imageUrl = '',
        bodyColor = colors.white,
        arguments: { scoreBackgroundColor = '#FFD95B', scoreTextColor = '#000000', scoreText = 'Your Score:' } = {},
        extraArguments: { currentDayPoints = '', totalScore = '' },
      },
      myRewardPoints = '',
    } = this.props;

    const buttonTextStyle = [styles.buttonText, { color: scoreTextColor }];
    const buttonTextBold = [styles.buttonText, { color: scoreTextColor }];
    const buttonContainerStyle = [
      styles.buttonContainer,
      { backgroundColor: scoreBackgroundColor },
    ];
    const headingStyle = [styles.title, { color: scoreBackgroundColor }];
    const bodyStyle = [styles.body, { color: bodyColor }];
    const isPointsTextShow = body.includes('%{current_day_points}');
    const messageParts = body.split('%{current_day_points}');
    return (
      <View
        style={memoize(
          () => [styles.container, { backgroundColor }],
          () => [backgroundColor],
        )()}
      >
        <View style={styles.contentContainer}>
          <>
            <Text style={headingStyle}>{title}</Text>
            <Text style={bodyStyle} numberOfLines={3} ellipsizeMode='tail'>
              {messageParts[0]}
              {isPointsTextShow && <Text style={styles.boldSubheading}>{currentDayPoints}</Text>}
              {messageParts[1]}
            </Text>
          </>
          <View style={buttonContainerStyle}>
            <Text style={buttonTextStyle}>
              {`${scoreText}`}
              <Text style={buttonTextBold}> {myRewardPoints || totalScore || 0}</Text>
            </Text>
          </View>
        </View>
        <FastImageView source={imageUrl} style={styles.image} />
      </View>
    );
  }
}

export default RoutineScoreFeatureCard;

const styles = StyleSheet.create({
  container: {
    borderRadius: 16,
    paddingLeft: 16,
    paddingTop: 12,
    flexDirection: 'row',
    marginTop: 25,
    overflow: 'visible',
    marginHorizontal: 6,
    width: getScreenWidth() - 60,
  },
  fullWidthContainerStyle: {
    borderRadius: 16,
    paddingLeft: 16,
    paddingTop: 12,
    flexDirection: 'row',
    marginTop: 25,
    overflow: 'visible',
    marginHorizontal: 6,
    width: getScreenWidth() - 24,
  },
  contentContainer: {
    flex: 1,
    alignItems: 'flex-start',
    marginBottom: 12,
    justifyContent: 'space-between',
  },
  title: {
    fontSize: size.h1,
    fontFamily: 'Roboto-Bold',
    marginBottom: 2,
  },
  subtitle: {
    color: colors.white,
    fontFamily: 'Roboto-Regular',
    fontSize: size.h3,
    marginBottom: 8,
  },
  buttonContainer: {
    backgroundColor: colors.routine_golden,
    paddingVertical: 3,
    paddingHorizontal: 8,
    borderRadius: 10,
    marginTop: 8,
  },
  buttonText: {
    color: colors.light_purple,
    fontSize: size.h4,
    fontFamily: 'Roboto-Bold',
  },
  image: {
    width: 110,
    marginTop: -25,
    height: 130,
    resizeMode: 'contain',
    marginBottom: 10,
  },
  boldSubheading: {
    color: colors.white,
    fontFamily: 'Roboto-Bold',
    fontSize: size.h0,
  },
});
